const isMobile = window.innerWidth <= 600

const styles = (theme) => ({
  iconColor: {
    color: theme.palette.white,
  },
  cardRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cardCol: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  start: {
    textAlign: 'start',
  },
  end: {
    textAlign: isMobile ? 'start' : 'end',
  },
  circle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    width: theme.spacing(20),
    height: theme.spacing(20),
    [theme.breakpoints.between('xs', 'sm')]: {
      width: theme.spacing(20),
      height: theme.spacing(20),
    },
  },
  operation: {
    color: theme.palette.text.primary,
    fontWeight: 'bold',
  },
  description: {
    color: theme.palette.text.secondary,
  },
  price: {
    fontWeight: 'bold',
    textAlign: 'end',
    color: theme.palette.text.primary,
  },
  pointer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
})

export default styles
